module.exports = __webpack_public_path__ + "static/media/Test.ai_logo_white.f147d431.svg";